import React from 'react';
import ProfileInstitution from '../../../components/Profile/ProfileInstitution';

const InstitutionProfile = ({Type}) => {
    return (
        <ProfileInstitution Type={Type}/>
    );
}

export default InstitutionProfile;
